/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsToggleMfa204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsToggleMfa505Schema = z.any();

export const optionsToggleMfaMutationResponseSchema = z.lazy(() => optionsToggleMfa204Schema);
